import { Head } from "@inertiajs/react";
import { Button, Box, Flex, Heading, Text, Container, Section } from "@radix-ui/themes";
import { CheckCircle2, Mail } from "lucide-react";

function ThankYou() {
  return (
    <>
      <Head title="Thanks for joining! - Formbot" />

      {/* Header */}
      <Box style={{
        borderBottom: "1px solid var(--gray-a5)",
        backgroundColor: "var(--color-background)",
      }}>
        <Container size="4">
          <Flex justify="between" align="center" py="4">
            <Heading size="6" style={{ color: "var(--accent-9)" }}>
              Formbot
            </Heading>
            <Button asChild variant="soft" size="2">
              <a href="/">
                Back to Home
              </a>
            </Button>
          </Flex>
        </Container>
      </Box>

      {/* Success Message */}
      <Section size="3">
        <Container size="2">
          <Flex
            direction="column"
            align="center"
            gap="6"
            style={{
              textAlign: "center",
              paddingTop: "var(--space-9)",
              paddingBottom: "var(--space-9)"
            }}
          >
            <Box style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              backgroundColor: "var(--accent-3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              <CheckCircle2 size={48} style={{ color: "var(--accent-9)" }} />
            </Box>

            <Box>
              <Heading size="9" mb="4">
                You're on the list!
              </Heading>
              <Text size="5" color="gray" style={{ maxWidth: "600px", margin: "0 auto" }}>
                Thank you for joining the Formbot waitlist. We'll email you as soon as we launch.
              </Text>
            </Box>

            <Box
              p="6"
              style={{
                backgroundColor: "var(--gray-a2)",
                borderRadius: "var(--radius-4)",
                border: "1px solid var(--gray-a5)",
                maxWidth: "500px",
                width: "100%"
              }}
            >
              <Flex direction="column" gap="4" align="center">
                <Mail size={32} style={{ color: "var(--accent-9)" }} />
                <Box style={{ textAlign: "center" }}>
                  <Heading size="4" mb="2">What happens next?</Heading>
                  <Text color="gray">
                    We're working hard to bring Formbot to life. You'll receive an email when we launch, along with exclusive early access benefits.
                  </Text>
                </Box>
              </Flex>
            </Box>

            <Flex gap="3" wrap="wrap" justify="center">
              <Button asChild variant="classic" size="3">
                <a href="/">
                  Back to Home
                </a>
              </Button>
              <Button asChild variant="soft" size="3">
                <a href="https://x.com/intent/tweet?text=I%20just%20joined%20the%20waitlist%20for%20Formbot%20-%20an%20AI-powered%20tool%20that%20analyzes%20survey%20responses%20instantly!%0A%0Ahttps%3A%2F%2Fformbotapp.com" target="_blank" rel="noopener noreferrer">
                  Share on X
                </a>
              </Button>
            </Flex>
          </Flex>
        </Container>
      </Section>

      {/* Footer */}
      <Box style={{
        borderTop: "1px solid var(--gray-a5)",
        backgroundColor: "var(--gray-a2)",
        padding: "var(--space-6) 0",
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0
      }}>
        <Container size="4">
          <Flex justify="center" align="center">
            <Text size="2" color="gray">
              © 2025 Formbot · Created by{" "}
              <a
                href="https://x.com/_vojto"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "var(--accent-11)",
                  textDecoration: "none"
                }}
                className="hover:opacity-75"
              >
                Vojtech Rinik
              </a>
            </Text>
          </Flex>
        </Container>
      </Box>
    </>
  );
}

// Disable the default layout for the thank you page
ThankYou.layout = (page: React.ReactNode) => page;

export default ThankYou;
